<script>
import TranslateForm from "./TranslateForm.vue";
import Translate from "./utils"
import {convert} from "./translate-lang-map";
export default {
  name: "TranslateRecipe",
  components: {TranslateForm},
  data() {
    return {
      showDialog: false,
      formData: {},
      targetForm: {},
      // 翻译语言
      translateLang: 'FR',
      translateInstance: null,
      data: {
        from: null,
        to: []
      }
    }
  },
  async created() {
    this.translateInstance = new Translate(this);
  },
  methods: {
    // 打开弹窗
    show(data) {
      this.data = {...data};
      this.$nextTick(() => {
        const data = this.translateInstance.transformTranslateData(this.recipe);
        this.formData = data;
        this.handleInitTranslateData(data);
        this.translateLang = this.data.to[0] || null;
        this.showDialog = true;
      })
    },

    // 初始化译文数据
    handleInitTranslateData(data) {
      const {to} = this.data;
      if(Array.isArray(to) && to.length) {
        to.forEach(item => {
          const copyData = JSON.parse(JSON.stringify(data));
          // 处理需要翻译的字段，初始化时为空
          for (const key in copyData) {
            if(!this.translateInstance.fields.includes(key)) continue;
            if(typeof copyData[key] === 'string') {
              copyData[key] = "";
            } else if(Array.isArray(copyData[key])) {
              copyData[key] = copyData[key].map(item => {
                item.value = "";
                return item;
              })
            }
          }
          this.$set(this.targetForm, item, copyData);
        })
      }
    },

    // 翻译
    async handleTranslate() {
      try {
        this.$customLoading.showLoading(this, "加载中", "body");
        const translateList = this.translateInstance.buildTranslateForm();
        const params = {
          translateList,
          from: convert(this.data.from),
          tos: this.data.to.map(lang => {
            return  convert(lang);
          })
        }
        const {data: res} = await this.$http.post(this.$api.translate, params);
        if(!Array.isArray(this.data.to)) {
          this.$message.error(this.$t('lang.翻译失败'));
          return;
        }
        this.data.to.forEach(lang => {
          const lowerCaseLang = convert(lang);
          this.targetForm[lang] = this.translateInstance.setTranslateData(res[lowerCaseLang], this.targetForm[lang]);
        })

      } catch (e) {
        console.log(e);
      } finally {
        this.$customLoading.hideLoading();
      }
    },

    // 加载分类数据
    handleGetCategoryData() {
      return new Promise((resolve, reject) => {
        const params = {code: this.recipe.recipeCategoryCode}
        this.$http.post(this.$api.recipeCategory.detail,  this.$qs.stringify(params)).then(res => {
          if(res.data.status !== 200) {
            reject(res);
            return;
          }
          resolve(res.data.data.recipeCategory);
        })
      })
    },


    // 更新分类
    async handleUpdateCategory() {
      try {
        const categoryData = await this.handleGetCategoryData();
        const {to} = this.data;
        to.forEach(lang => {
          categoryData.recipeCategoryLang[lang] = this.targetForm[lang]?.category;
        })
        await this.$http.post(this.$api.recipeCategory.update, categoryData);
      } catch (e) {
        console.log(e);
        this.$message.error(this.$t('lang.更新失败'));
      }
    },

    // 确认
    handleConfirm() {
      this.$confirm(this.$t('lang.请确认多语言食谱翻译内容无误'), this.$t('lang.提示'), {
        confirmButtonText: this.$t('lang.确定'),
        cancelButtonText: this.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        if(!Array.isArray(this.data.to)) {
          this.$message.error(this.$t('lang.确认失败'));
          return;
        }
        let recipe = JSON.parse(JSON.stringify(this.recipe));
        this.data.to.forEach(lang => {
          const recipeData = this.translateInstance.buildRecipeForm(this.targetForm[lang], recipe, lang);
          recipe = Object.assign({}, recipe, recipeData);
        })
        console.log('recipe', recipe);
        this.$store.commit("CHANGE_RECIPE", recipe);
        this.$emit("confirm", recipe);
        this.handleUpdateCategory();
        this.$bus.$emit('translateRecipe')
        this.showDialog = false;
      })
    }
  },
  computed: {
    recipe() {
      return this.$store.state.recipe;
    }
  },
}
</script>

<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false">
    <div class="wrapper">
      <div class="left">
        <h3>{{$t('lang.原文')}}</h3>
        <el-radio-group size="small" :value="data.from">
          <el-radio-button :label="data.from">{{ data.from }}</el-radio-button>
        </el-radio-group>
        <translate-form disabled :data="formData" />
      </div>
      <div class="right">
        <h3>{{$t('lang.译文')}}</h3>
        <el-radio-group size="small" v-model="translateLang">
          <el-radio-button v-for="(item, index) in data.to" :key="index" :label="item">{{ item }}</el-radio-button>
        </el-radio-group>
        <translate-form :data="targetForm[translateLang]" />
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <el-button type="primary" size="small" @click="handleTranslate">{{ $t('lang.一键翻译') }}</el-button>
        <el-button type="success" size="small" @click="handleConfirm">{{ $t('lang.确定') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

.wrapper {
  display: flex;
  max-height: 800px;
  overflow-y: auto;
  box-sizing: border-box;
  padding-right: 12px;
}


.left,
.right {
  flex: 1;
}

.left {
  height: 100%;
  border-right: 1px dashed #ddd;
  padding-right: 18px;
  margin-right: 18px;
}

</style>
